import React, { useState, useEffect } from 'react';

import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import db from "./Firebase";
import { CSVLink } from "react-csv";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function DownloadCertificateNew() {
    const navigate = useNavigate();
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [lastVisible, setLastVisible] = useState(null);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }
    }, [navigate]);

    const headers = [
        "Workshop Name",
        "Full Name",
        "Phone No",
        "Created Date",
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const snapshot = await db.collection("downloaded_cretificate_data")
                    .orderBy("created_date", "desc")
                    .limit(150)
                    .get();

                const lastVisibleDoc = snapshot.docs[snapshot.docs.length - 1];
                setLastVisible(lastVisibleDoc);

                const fetchedData = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }));

                setData(fetchedData);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    const loadMoreData = async () => {
        try {
            const snapshot = await db.collection("downloaded_cretificate_data")
                .orderBy("created_date", "desc")
                .startAfter(lastVisible)
                .limit(150)
                .get();

            const lastVisibleDoc = snapshot.docs[snapshot.docs.length - 1];
            setLastVisible(lastVisibleDoc);

            if (snapshot.docs.length < 150) {
                setHasMore(false);
            }

            const fetchedData = snapshot.docs.map((doc) => ({
                id: doc.id,
                data: doc.data(),
            }));

            setData((prevData) => [...prevData, ...fetchedData]);
        } catch (error) {
            console.error("Error fetching more data:", error);
        }
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // 1. Get unique records by phone
    // const uniqueMap = new Map();
    // data.forEach(item => {
    //     const phone = item.data.phone;
    //     if (!uniqueMap.has(phone)) {
    //         uniqueMap.set(phone, item);
    //     }
    // });
    // const uniqueData = Array.from(uniqueMap.values());

    // // 2. Filter the unique records
    // const filteredData = uniqueData.filter((item) => {
    //     const workshop_name = item.data.workshop_name?.toLowerCase() || "";
    //     const name = item.data.name?.toLowerCase() || "";
    //     const phone = item.data.phone?.toLowerCase() || "";
    //     const query = searchQuery.toLowerCase();

    //     return (
    //         workshop_name.includes(query) ||
    //         name.includes(query) ||
    //         phone.includes(query)
    //     );
    // });

    const uniqueMap = new Map();
    data.forEach(item => {
        const phone = item.data.phone;
        const workshop = item.data.workshop_name;
        if (phone && workshop) {
            const key = `${phone}_${workshop}`.toLowerCase(); // ensure consistent casing
            if (!uniqueMap.has(key)) {
                uniqueMap.set(key, item);
            }
        }
    });
    const uniqueData = Array.from(uniqueMap.values());

    // 2. Filter the unique records
    const filteredData = uniqueData.filter((item) => {
        const workshop_name = item.data.workshop_name?.toLowerCase() || "";
        const name = item.data.name?.toLowerCase() || "";
        const phone = item.data.phone?.toLowerCase() || "";
        const query = searchQuery.toLowerCase();

        return (
            workshop_name.includes(query) ||
            name.includes(query) ||
            phone.includes(query)
        );
    });


    // 3. Prepare full unique data for Excel
    // const handleExportAllData = async () => {
    //     try {
    //         const snapshot = await db.collection("downloaded_cretificate_data").get();
    //         const allData = snapshot.docs.map((doc) => doc.data());

    //         // De-duplicate by phone
    //         const uniqueMap = new Map();
    //         allData.forEach(item => {
    //             if (!uniqueMap.has(item.phone)) {
    //                 uniqueMap.set(item.phone, item);
    //             }
    //         });

    //         const rows = Array.from(uniqueMap.values()).map(item => ({
    //             "Workshop Name": item.workshop_name,
    //             "Full Name": item.name,
    //             "Phone No": item.phone,
    //             "Created Date": moment(item.created_date.toDate()).format("MM/DD/YY, h:mm a")
    //         }));

    //         const worksheet = XLSX.utils.json_to_sheet(rows);
    //         const workbook = XLSX.utils.book_new();
    //         XLSX.utils.book_append_sheet(workbook, worksheet, "Certificates");

    //         const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    //         saveAs(new Blob([wbout], { type: "application/octet-stream" }), "AllCertificates.xlsx");

    //     } catch (error) {
    //         console.error("Error exporting all data:", error);
    //     }
    // };

    const handleExportAllData = async () => {
        try {
            const snapshot = await db.collection("downloaded_cretificate_data").get();
            const allData = snapshot.docs.map((doc) => doc.data());

            // De-duplicate based on phone + workshop_name
            const uniqueMap = new Map();
            allData.forEach(item => {
                const key = `${item.phone}_${item.workshop_name}`;
                if (item.phone && item.workshop_name && !uniqueMap.has(key)) {
                    uniqueMap.set(key, item);
                }
            });

            const rows = Array.from(uniqueMap.values()).map(item => ({
                "Workshop Name": item.workshop_name,
                "Full Name": item.name,
                "Phone No": item.phone,
                "Created Date": moment(item.created_date.toDate()).format("MM/DD/YY, h:mm a")
            }));

            const worksheet = XLSX.utils.json_to_sheet(rows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Certificates");

            const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            saveAs(new Blob([wbout], { type: "application/octet-stream" }), "AllCertificates.xlsx");

        } catch (error) {
            console.error("Error exporting all data:", error);
        }
    };



    return (
        <>
            <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
                <div className="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                    <Link to="/">
                        <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                    </Link>
                    <button className="btn bg-gradient-secondary btn-sm mb-0 mr-2" onClick={handleExportAllData}>
                        Download All Excel
                    </button>
                </div>
                <div className="p-2">
                    <div className="card">
                        <div className="card-header pb-0 px-3">
                            <h6 className="mb-2">Certificate Download History || {`Records : ${filteredData.length}`}</h6>
                        </div>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search by Workshop Name, Full Name, Phone No"
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <div className="card">
                            <div className="table-responsive fix-width scroll-inner">
                                <table className="table table-bordered table-hover">
                                    <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                                        <tr style={{ textAlign: "left" }}>
                                            <th className="col ps-2">Workshop Name</th>
                                            <th className="col ps-2">Full Name</th>
                                            <th className="col ps-2">Phone No</th>
                                            <th className="col ps-2">Created Date</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: "left" }}>
                                        {filteredData.map((item, index) => (
                                            <tr key={item.id}>
                                                <td><p className="text-xs mb-0">{item.data.workshop_name}</p></td>
                                                <td><p className="text-xs mb-0">{item.data.name}</p></td>
                                                <td><p className="text-xs mb-0">{item.data.phone}</p></td>
                                                <td>
                                                    <div className="d-flex px-2 py-1">
                                                        <div className="d-flex flex-column justify-content-center">
                                                            <h6 className="mb-0 text-xs">
                                                                {moment(item.data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {hasMore && (
                                    <div className="d-flex justify-content-between" style={{ paddingTop: "2rem" }}>
                                        <button onClick={loadMoreData} className="btn btn-primary">Load More</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default DownloadCertificateNew;
